import React from "react";
import { Tooltip } from "@culturehq/components";
import { t } from "app/utils";

const displayTooltip = (display: boolean, centsField: any) => {
  if (display) {
    return (
      <Tooltip tip={t("This social media is disabled for your organization. You can enable this social media in your Admin Integrations.")}>
        {centsField}
      </Tooltip>
    );
  }

  return centsField;
};

export default displayTooltip;
